import * as z from "zod";

const startBillingCurrencyMigrationInput_ = z.object({});
export const startBillingCurrencyMigrationInput: z.ZodType<StartBillingCurrencyMigrationInput> =
  startBillingCurrencyMigrationInput_;
export interface StartBillingCurrencyMigrationInput extends z.infer<
  typeof startBillingCurrencyMigrationInput_
> {}

const startBillingCurrencyMigrationOutput_ = z.object({
  /** Shopify approval URL; the merchant must accept before the switch takes effect. */
  confirmationUrl: z.string(),
});
export const startBillingCurrencyMigrationOutput: z.ZodType<StartBillingCurrencyMigrationOutput> =
  startBillingCurrencyMigrationOutput_;
export interface StartBillingCurrencyMigrationOutput extends z.infer<
  typeof startBillingCurrencyMigrationOutput_
> {}

export const startBillingCurrencyMigration = {
  name: "startBillingCurrencyMigration" as const,
  input: startBillingCurrencyMigrationInput,
  output: startBillingCurrencyMigrationOutput,
};
